import axios from 'axios'
export const state = () => ({
  profile: null,
  profile_id: null,
  profile_avatar: null,
  ktp: null,
  npwp: null,
  status: null,
  verification: null,
  correction: null,
  need_verify: false,
  password: null,
  need_edit: false,
  last_reject_data: null,
  email: null,
  token: null,
  register_type: null
})

export const mutations = {
  SET_PROFILE: (state, data) => {
    state.profile = data
  },
  SET_PROFILE_ID: (state, data) => {
    state.profile_id = data
  },
  SET_STATUS: (state, data) => {
    state.status = data
  },
  SET_VERIFICATION: (state, data) => {
    state.verification = data
  },
  SET_CORRECTION: (state, data) => {
    state.correction = data
  },
  SET_NEED_VERIFY: (state, data) => {
    state.need_verify = data
  },
  SET_PASSWORD: (state, data) => {
    state.password = data
  },
  SET_AVATAR: (state, data) => {
    state.profile_avatar = data
  },
  SET_KTP: (state, data) => {
    state.ktp = data
  },
  SET_NPWP: (state, data) => {
    state.npwp = data
  },
  SET_EMAIL: (state, data) => {
    state.email = data
  },
  SET_TOKEN: (state, data) => {
    state.token = data
  },
  SET_NEED_EDIT: (state, data) => {
    state.need_edit = data
  },
  SET_LAST_REJECT_DATA: (state, data) => {
    state.last_reject_data = data
    localStorage.setItem('last_reject_data', JSON.stringify(data))
  },
  SET_REGISTER_TYPE: (state, data) => {
    state.register_type = data
  }
}

export const actions = {
  setNeedEdit ({ commit }, data) {
    commit('SET_NEED_EDIT', data)
  },
  deleteDocument ({ commit }, data) {
    if (data === 'ktp') {
      commit('SET_KTP', null)
    } else if (data === 'avatar') {
      commit('SET_AVATAR', null)
    } else if (data === 'npwp') {
      commit('SET_NPWP', null)
    }
  },
  checkNumberAccountBank ({ commit }, payload) {
    const { bankID, accountNumber, accountName } = payload
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.BASE_API_V4}/payment/bank/check?BankID=${bankID}&AccountNumber=${accountNumber}&AccountName=${accountName}&BankType=BANK_ACCOUNT`)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  setVerify ({ commit }, data) {
    commit('SET_NEED_VERIFY', data)
  },
  getStep ({ commit }, data) {
    const { id, token } = data

    return new Promise((resolve, reject) => {
      this.$axios.get(`/clinic/doctor/pending/${id}/registration/status/${token}`)
        .then(function (response) {
          const res = response.data
          commit('SET_STATUS', res.Data)
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  registerAccount ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.post('/clinic/doctor/register', data)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getRegistrationStatus ({ commit, state }, payload) {
    const { id, token } = payload
    return new Promise((resolve, reject) => {
      this.$axios.get(`/clinic/doctor/pending/${id}/registration/status/${token}`)
        .then(function (response) {
          const res = response.data
          if (res.Data) {
            commit('SET_STATUS', res.Data.Status)
          }
          resolve(res.Data)
        }).catch(function (error) {
          reject(error)
        })
    })
  },

  getVerificationStatus ({ commit, state }, payload) {
    const { email, token, fromEmail } = payload
    let path = `doctor/verification/check/?email=${email}&token=${token}`
    if (fromEmail) {
      path = `doctor/verification/check/?email=${email}&token=${token}&fromEmail=${fromEmail}`
    }
    return new Promise((resolve, reject) => {
      this.$axios.get(path)
        .then(function (response) {
          const res = response.data
          commit('SET_VERIFICATION', res)
          if (res.Data && res.Data.Corrections) {
            commit('SET_CORRECTION', res.Data.Corrections)
          }
          resolve(res)
        }).catch(function (error) {
          reject(error)
        })
    })
  },

  getListSpecialist () {
    return new Promise((resolve, reject) => {
      // this.$axios.get('/doctor/types')
      // temporary until BE update doctor types ini API V3
      this.$axios.get('https://server13.yesdok.com/api/3.0b/doctor/types')
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  updateData ({ commit, rootState }, formData) {
    return new Promise((resolve, reject) => {
      this.$axios.post('/clinic/doctor/pending/' + rootState.register_doctor.profile_id + '/update', formData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getDoctorProfile ({ commit, state, rootState }, id) {
    return new Promise((resolve, reject) => {
      this.$axios.get('/clinic/doctor/pending/' + id)
        .then(function (response) {
          const res = response.data
          commit('SET_PROFILE', res.Data)
          commit('SET_PROFILE_ID', res.Data.ID)
          commit('SET_AVATAR', res.Data.AvatarUrl)
          commit('SET_KTP', res.Data.KTPUrl)
          commit('SET_NPWP', res.Data.FileNPWPUrl)
          commit('SET_EMAIL', res.Data.Email)
          commit('SET_TOKEN', res.Data.EmailVerificationCode)
          commit('SET_REGISTER_TYPE', res.Data.DoctorType)
          resolve(res.Data)
        }).catch(function (error) {
          reject(error)
        })
    })
  },

  getRejectProfile ({ commit, state, rootState }, id) {
    return new Promise((resolve, reject) => {
      this.$axios.get('/clinic/doctor/pending/' + id)
        .then(function (response) {
          const res = response.data
          commit('SET_LAST_REJECT_DATA', res.Data)
          commit('SET_PROFILE', res.Data)
          commit('SET_PROFILE_ID', res.Data.ID)
          commit('SET_AVATAR', res.Data.AvatarUrl)
          commit('SET_KTP', res.Data.KTPUrl)
          commit('SET_NPWP', res.Data.FileNPWPUrl)
          resolve(res.Data)
        }).catch(function (error) {
          reject(error)
        })
    })
  },

  checkUsername ({ commit, state }, url) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('PersonalUrl', url)

      this.$axios.post('/clinic/doctor/pending/check/url', formData)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          reject(error)
        })
    })
  },

  requestOTP ({ commit, rootState }, payload) {
    const { id, data } = payload
    if (data.DoctorType && data.DoctorType === 'PSYCHOLOGIST') {
      data.DoctorType = 'PSYCHOLOGIST'
    }
    return new Promise((resolve, reject) => {
      this.$axios.post(`/doctor/pending/${id}/send/otp`, data || null)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          reject(error.data)
        })
    })
  },

  verifyOTP ({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      const { id, otp, WhatsappNumber, DoctorType } = payload
      const data = {
        OTP: otp,
        WhatsappNumber
      }

      if (DoctorType && DoctorType === 'PSYCHOLOGIST') {
        data.DoctorType = 'PSYCHOLOGIST'
      }

      this.$axios.post(`/clinic/doctor/pending/${id}/verify/otp`, data)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          reject(error)
        })
    })
  },
  resendEmail ({ commit, rootState }, payload) {
    const { id, email, DoctorType } = payload
    const data = {
      Email: email
    }

    if (DoctorType && DoctorType === 'PSYCHOLOGIST') {
      data.DoctorType = 'PSYCHOLOGIST'
    }
    return new Promise((resolve, reject) => {
      this.$axios.post(`/clinic/doctor/pending/${id}/send/email`, data)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          reject(error)
        })
    })
  },
  getDataBank () {
    return new Promise((resolve, reject) => {
      this.$axios.get('/doctor/list/bank')
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getPureDocument ({ commit }, type) {
    return new Promise((resolve, reject) => {
      let path = '/clinic/doctor/tnc'
      if (type && type === 'General Doctor') {
        path = '/doctor/tnc/general'
      }

      this.$axios.get(path)
        .then(function (responseInfo) {
          resolve(responseInfo)
        }).catch(function (error) {
          reject(error)
        })
    })
  },
  acceptDoctorTnc ({ commit }, id) {
    return new Promise((resolve, reject) => {
      this.$axios.get(`/clinic/doctor/tnc/${id}/accept`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getBankCities ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(`/cities?q=${data}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  suggestionPublicID ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('FullName', data)
      this.$axios.post('/clinic/doctor/pending/suggestion/username', formData)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })

        .catch(function (error) {
          reject(error)
        })
    })
  },

  forgotPasswordUnverified ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const payload = {
        Email: data,
        IsVerified: false
      }

      this.$axios.post('/clinic/doctor/forgot-password/email', payload)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })

        .catch(function (error) {
          reject(error)
        })
    })
  },

  verifyForgotPassword ({ commit }, token) {
    return new Promise((resolve, reject) => {
      this.$axios.get(`/clinic/doctor/forgot-password/verify/${token}`)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  changeForgotPasswordUnverified ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const { token, Password, Password_confirmation } = data
      const payload = {
        Password,
        Password_confirmation
      }
      this.$axios.post(`/clinic/doctor/forgot-password/change/${token}`, payload)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })

        .catch(function (error) {
          reject(error)
        })
    })
  },
  updatePhone ({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.BASE_API_V4}/doctor/pending/change/phone`, payload, {
        headers: {
          Authorization: 'Bearer ' + rootState.token
        }
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}
